import React, { useEffect, useState } from "react";
import TypeIt from "typeit-react";
import "./Chatbot.css";

function Chatbot() {
  const [isShowing, setIsShowing] = useState(false);
  const [inpPrompt, setInpPrompt] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "chatbot",
      message:
        "I am EnVeer, a chatbot assistant that provides information about the 5YNOW app and the environment. I am here to help you with any questions or queries you may have related to the app and environmental sustainability.",
    },
  ]);
  const handleEnter = async (event) => {
    if (isShowing && event.key === "Enter") {
      setMessages((messages) => [
        ...messages,
        { role: "user", message: inpPrompt },
      ]);
      try {
        const response = await fetch(`http://localhost:5000/chatbot`, {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify([{ text: inpPrompt }]),
        });

        if (response.ok) {
          // Server returned a successful response
          const result = await response.text();
          console.log(result);
          setMessages((messages) => [
            ...messages,
            { role: "chatbot", message: result },
          ]);
        } else {
          console.log("Server error:", response.status, response.statusText);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }

      setInpPrompt("");
    }
  };
  return (
    <div className="chat-container">
      {isShowing ? (
        <div className="chat-box">
          <div className="chat-header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="delete-icon"
              viewBox="0 0 16 16"
              onClick={() => {
                setMessages([
                  {
                    role: "chatbot",
                    message:
                      "I am EnVeer, a chatbot assistant that provides information about the 5YNOW app and the environment. I am here to help you with any questions or queries you may have related to the app and environmental sustainability.",
                  },
                ]);
              }}
            >
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
            </svg>

            <h1>ChatBot</h1>
            <svg
              onClick={() => {
                setIsShowing(!isShowing);
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              className="back-icon"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
              />
            </svg>
          </div>
          <div className="text-cont">
            {messages.map((val) => {
              let color;
              if (val.role === "user") {
                color = "lightpink";
              } else {
                color = "#6667AB";
              }
              return (
                <div>
                  <p>{val.role}</p>
                  <div
                    style={{
                      width: "80%",
                      backgroundColor: color,
                      borderRadius: "20px",
                      fontSize: 13,
                      margin: "0 auto",
                    }}
                  >
                    <TypeIt
                      element={"p"}
                      options={{
                        strings: [val.message],
                        speed: 1,
                        waitUntilVisible: true,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <input
            className="chat-inp"
            value={inpPrompt}
            onChange={(e) => {
              setInpPrompt(e.target.value);
            }}
            onKeyDown={handleEnter}
            placeholder="Clear all your doubts"
          />
        </div>
      ) : (
        <noscript />
      )}
      <img
        onClick={() => {
          setIsShowing(!isShowing);
        }}
        className="chat-icon"
        src="https://png.pngtree.com/png-vector/20230225/ourmid/pngtree-smart-chatbot-cartoon-clipart-png-image_6620453.png"
      />
    </div>
  );
}

export default Chatbot;
